import { useEffect } from "react";
import { useSubscription } from "@apollo/client";
import { AgendaRequest, OnCreateAgendaRequestByCompanyIdSubscription, OnCreateAgendaRequestByCompanyIdSubscriptionVariables } from "../../../graphql/API";
import { onCreateAgendaRequestByCompanyId } from "../queries";

const SubscriptionComRequestForSwapWrapper: React.FC<{
  comId: string;
  onNewRequest: (request: AgendaRequest) => void;
  subscriptionKey: number;
  onError?: () => void;
}> = ({ comId, onNewRequest, subscriptionKey, onError }) => {
    const { data, error } = useSubscription<
      OnCreateAgendaRequestByCompanyIdSubscription,
      OnCreateAgendaRequestByCompanyIdSubscriptionVariables
      >(onCreateAgendaRequestByCompanyId, {
        variables: { comId, 
          filter: {
            type: {eq: "swap"}
        }},
        // skip: !comId,
    });
  
    useEffect(() => {
      // if (data?.onCreateAgendaPostByCompanyId) {
      //   onNewPost(data.onCreateAgendaPostByCompanyId as AgendaPost);
      // }
      const request = data?.onCreateAgendaRequestByCompanyId;
      if (request?.type === "swap") {
        onNewRequest(request as AgendaRequest);
      }
    }, [data]);
  
    useEffect(() => {
        if (error) {
          console.error("Subscription error");//:", error);
          onError?.();
        }
      }, [error]);
  
    return null;
  };
 export default SubscriptionComRequestForSwapWrapper  